import React from 'react';
import './InvestmentSection.scss';

const InvestmentSection = () => {
  return (
    <section className="investment-section">
      <div className="content">
        <h1>Profitable Gold Investment</h1>
        <p>Profit & Prosper through our finely tuned investment schemes.</p>
        {/* <button className="join-button">Join Now</button> */}
      </div>
    </section>
  );
};

export default InvestmentSection;
